import { inject, observer } from "mobx-react";
import React, { ReactChildren } from "react";
import { CommonsStore } from "../../../model/CommonsStore";
import { NestedListWhenDrawerCollapsed } from "./NestedListWhenDrawerCollapsed";
import { NestedListWhenDrawerOpened } from "./NestedListWhenDrawerOpened";
import { darken, lighten, Theme } from "@material-ui/core";
import {
  SecuredListLink,
  SecurityProvider,
  SecuredNestedListLinkWhenDrawerCollapsed
} from "../../Secured";
export interface ListItemObj {
  key: string;
  to: string;
  title: string | ReactChildren;
  security?: string[] | string;
}

export const expandedTextStyles = (theme: Theme) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderLeft: 0,
  borderRadius: "0 3px 3px 0",
  boxShadow: "2px 1px 3px rgba(0,0,0,0.1)",
  color: theme.palette.getContrastText(theme.palette.background.paper),
  display: "block",
  left: "70px",
  width: "265px",
  padding: "12px 15px",
  position: "fixed",
  marginTop: 0,
  marginBottom: 0,
  "&:hover": {
    backgroundColor:
      theme.palette.type == "dark"
        ? lighten(theme.palette.background.paper, 0.1)
        : darken(theme.palette.background.paper, 0.1)
  }
});

export interface NestedListProps {
  commons?: CommonsStore;
  icon?: any;
  nestedListItems: ListItemObj[];
  text?: any;
}

interface NestedListState {
  open: boolean;
  isTextExpanded: boolean;
}

@inject("auth", "commons")
@observer
export class NestedListWrapper extends React.Component<
  NestedListProps,
  NestedListState
> {
  // todo: open if contains active link
  public state = {
    open: false,
    isTextExpanded: false
  };

  public toggleNestedListOpen = () => {
    this.setState({ open: !this.state.open });
  };

  public expand = () => {
    this.setState({ isTextExpanded: true });
  };

  public collapse = () => {
    this.setState({
      isTextExpanded: false
    });
  };

  public collapseAndClose = () => {
    this.setState({
      isTextExpanded: false,
      open: false
    });
  };

  public render() {
    const Icon = this.props.icon;
    const { sideMenuDrawerExpanded } = this.props.commons!;

    const { nestedListItems, text } = this.props;

    const { isTextExpanded, open } = this.state;

    return (
      <>
        {sideMenuDrawerExpanded ? (
          <NestedListWhenDrawerOpened
            collapse={this.collapse}
            expand={this.expand}
            Icon={Icon}
            open={open}
            text={text}
            toggleNestedListOpen={this.toggleNestedListOpen}
          >
            {nestedListItems.map((item: ListItemObj) => (
              <SecurityProvider
                security={{ readableRole: item.security }}
                key={item.key}
              >
                <SecuredListLink
                  requiredAccess={"readable"}
                  isNested={true}
                  key={item.key}
                  to={item.to}
                >
                  {item.title}
                </SecuredListLink>
              </SecurityProvider>
            ))}
          </NestedListWhenDrawerOpened>
        ) : (
          <NestedListWhenDrawerCollapsed
            collapse={this.collapseAndClose}
            expand={this.expand}
            Icon={Icon}
            isTextExpanded={isTextExpanded}
            open={open}
            text={text}
            toggleNestedListOpen={this.toggleNestedListOpen}
          >
            {nestedListItems.map((item: ListItemObj) => (
              <SecurityProvider
                security={{ readableRole: item.security }}
                key={item.key}
              >
                <SecuredNestedListLinkWhenDrawerCollapsed
                  key={item.key}
                  to={item.to}
                  requiredAccess={"readable"}
                >
                  {item.title}
                </SecuredNestedListLinkWhenDrawerCollapsed>
              </SecurityProvider>
            ))}
          </NestedListWhenDrawerCollapsed>
        )}
      </>
    );
  }
}
